// extracted by mini-css-extract-plugin
export var hideEditor = "_na-2";
export var infoIcon = "_na-3";
export var label = "_na-1";
export var labelContainer = "_na-0";
export var readonlyText = "_na-4";